import { createApp } from 'vue';
import WordToPdfConverter from '../Components/WordToPdfConverter.vue';

const root = document.getElementById('word-to-pdf-converter');
if (root) {
  createApp(WordToPdfConverter).mount('#word-to-pdf-converter');
}
